import React, { useCallback, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import Comments from "./Comments/index";
import LikeToggle from "../common/LikeToggle/index";

import { addComment, loadDetailPost } from "redux/modules/postSlice";

import { DetailLine } from "../common/commonStyle";
import {
  DetailCategory,
  PostInfo,
  DetailContent,
  DetailAside,
  DetailBoldLine,
  DetailComments,
  Embedded,
} from "./DetailPostStyle";

import PostImages from "../PostImages";

function DetailPost({ post }) {
  const dispatch = useDispatch();
  const textareaRef = useRef(null);
  const [commentLength, setCommentLength] = useState(0);
  const [focus, setFocus] = useState("blur");

  function urlify(text) {
    const urlReg = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlReg, function (url) {
      return (
        '<a href="' +
        url +
        '" target="_blank" rel="noopener noreferrer">' +
        url +
        "</a>"
      );
    });
  }

  function embeddedUrl(Ogtag) {
    return (
      "<a href=" +
      Ogtag.og_url +
      " target=_blank rel=noopener noreferrer>" +
      "<article>" +
      "<main>" +
      "<h1>" +
      Ogtag.og_title +
      "</h1>" +
      "<div>" +
      "<p>" +
      Ogtag.og_desc +
      "</p>" +
      "</div>" +
      "</main>" +
      "<img src=" +
      Ogtag.og_images +
      " alt='link image' />" +
      "</article>" +
      "</a>"
    );
  }

  const onChangeComment = useCallback((e) => {
    setCommentLength(e.target.value.length);

    // 자동높이조절
    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  }, []);

  // 댓글 등록
  const onClickComment = useCallback(() => {
    const payload = {
      boardId: post.boardId,
      content: textareaRef.current.value,
    };

    dispatch(addComment(payload))
      .unwrap()
      .then(() => {
        textareaRef.current.value = "";
        setCommentLength(0);
        setFocus("blur");
        textareaRef.current.blur();
        dispatch(loadDetailPost(post.boardId));
      });
  }, [dispatch, post.boardId]);

  return (
    <>
      <div>
        <DetailCategory>
          <span>{post.category}</span>
        </DetailCategory>

        <PostInfo>
          <div className="profileInfo">
            <img
              className="profileImg"
              referrerPolicy="no-referrer"
              src={post.profileImage}
              alt="profileImg"
            />
            <div className="nickAndCreateAt">
              <div className="detail-nickname">{post.nickname}</div>
              <div className="detail-createAt">
                {post.createdDate.substr(0, 10).replaceAll("-", ".")}
              </div>
            </div>
          </div>
        </PostInfo>

        <DetailContent>
          {post.images[0] && <PostImages images={post.images} />}
          <div
            className="contentUrlify"
            dangerouslySetInnerHTML={{ __html: urlify(post.content) }}
          ></div>
          {post.Ogtag.length > 0 &&
            post.Ogtag.map((v, i) => (
              <Embedded
                dangerouslySetInnerHTML={{
                  __html: embeddedUrl(post.Ogtag[i]),
                }}
              ></Embedded>
            ))}
        </DetailContent>
      </div>
      <DetailLine />
      <DetailAside>
        <div className="detail-liked">
          <LikeToggle el={post} detailPage={true} />
        </div>

        <div className="detail-comments">
          <img src="/img/comment.svg" alt="댓글" />
          <span>댓글</span>
          <span>{post.commentCount}</span>
        </div>
      </DetailAside>
      <DetailBoldLine />
      <DetailComments>
        {post.commentCount === "0" ? (
          <div className="noComment">
            아직 댓글이 없어요. <br />
            가장 먼저 댓글을 남겨보세요!
          </div>
        ) : (
          <div className="isComment">
            {post.comments?.map((comment) => (
              <Comments post={post} comment={comment} />
            ))}
          </div>
        )}
        <div className="commentsMargin">
          <div className="inputComments">
            <textarea
              ref={textareaRef}
              className={focus}
              type="text"
              rows="1"
              maxLength="80"
              placeholder="댓글을 입력해 주세요"
              onFocus={() => setFocus("focus")}
              onBlur={() => setFocus("blur")}
              onChange={(e) => onChangeComment(e)}
            />
            {(focus === "focus" || commentLength > 0) && (
              <div
                className="textareaAside"
                onClick={() => {
                  textareaRef.current.focus();
                }}
              >
                <div>{commentLength}/80</div>
                <button
                  className={commentLength > 0 ? "orange" : "black"}
                  onClick={onClickComment}
                >
                  등록
                </button>
              </div>
            )}
          </div>
        </div>
      </DetailComments>
    </>
  );
}

export default DetailPost;
